<template>
  <section class="px-4 pb-20 pt-10 md:px-8">
    <div class="mx-a max-w-256 rounded-lg bg-grey-90 px-6 py-10 lg:px-20 lg:py-16">
      <div class="mx-a max-w-168">
        <h2 class="text-center title-2">
          {{ content.heading }}
        </h2>
        <div class="my-6 flex items-center gap-3 b b-grey-70 rounded-lg p-3">
          <vf-icon name="benefit-discount" size="xl" />
          <p class="text-sm lh-tight">
            {{ replaceAll($t.loyaltyProgrammeSignInPromotion, {
              percent: $feature.configSignUp?.loyaltyRewardPercent,
            }) }}
          </p>
        </div>
        <base-form :form validate-on="submit" @submit="openSignIn">
          <vf-form-field
            v-slot="{ attrs, invalid }"
            :hint="$t.emailFormatHint"
            name="email"
            :rule="[validateRequired($t.email), validateEmail(), validateMaxLength(100)]"
          >
            <input-email
              v-model="form.email"
              v-bind="attrs"
              :hide-validation-icons="invalid === undefined"
              :label="content.emailLabel"
            />
          </vf-form-field>
          <vf-button class="mt-4 w-full" type="submit" variant="loyalty">
            {{ content.joinNowLabel }}
          </vf-button>
        </base-form>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps<{
  content: {
    heading: string
    emailLabel: string
    joinNowLabel: string
  }
}>()

const { DialogSignIn } = useDialogsStore()
const { $t } = useNuxtApp()
const { validateEmail, validateMaxLength, validateRequired } = useLocalizedValidators()

const form = reactive({
  email: ''
})

function openSignIn() {
  DialogSignIn.open({ formLocation: 'modal:single:pop-up:none', email: form.email })
}
</script>
